import React, { Fragment } from 'react';
import { animated, to, SpringValue } from '@react-spring/web';

import icon from '@images/wysiwyg_editor/add_text_button_icon.svg';

type TProps = {
  location: {
    x: SpringValue<number>;
    width: SpringValue<number>;
    y: SpringValue<number>;
    height: SpringValue<number>;
  };
  showBorder: boolean;
  stackOrder: number;
  text: string;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export default function AddTextButton({
  location,
  showBorder,
  text,
  stackOrder,
  onClick,
  onMouseEnter,
  onMouseLeave
}: TProps): React.ReactElement {
  return (
    <animated.button
      style={{
        alignItems: 'center',
        background: '#fbfcfe',
        border: showBorder ? '1px dashed #A5C7E2' : '',
        color: '#87929D',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Assistant, Arial, sans-serif',
        fontSize: '1.4rem',
        fontWeight: 400,
        height: location.height,
        justifyContent: 'center',
        left: location.x,
        lineHeight: '1.5',
        outline: 'none',
        padding: '0.5rem 0.2rem',
        position: 'absolute',
        top: location.y,
        width: location.width,
        zIndex: stackOrder
      }}
      type="button"
      onPointerDown={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Fragment>
        <animated.img
          src={icon as string}
          alt={text}
          style={{
            margin: '5px 0',
            display: 'block',
            maxHeight: to([location.height], (height) => height - 4)
          }}
        />
        <animated.span
          style={{
            display: to([location.height, location.width], (height, width) => {
              return height * width >= 5000 && height > 64 ? 'block' : 'none';
            })
          }}
        >
          {text}
        </animated.span>
      </Fragment>
    </animated.button>
  );
}
